module.exports = __webpack_public_path__ + "static/img/number_theory.0207bda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/number_theory.jpg
// module id = d9s0
// module chunks = 0